//import api from '../api';
import { newAPIPost } from '../api/index.js';

export default {
    state: {
        gstDriverMaster: [],
        searchRequest: null,
      },

      mutations: {
        updateGSTDriverMaster(state, list) {
          state.gstDriverMaster = list;
        },
        updateSearchGSTDriverMasterRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },


      actions: {
        async gstDriverMaster({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))
          console.log(requestToSend);
          const st = performance.now();
          //const result = await api.post('/api/w/gstMasterData/driverMasterData', requestToSend);
          const result = await newAPIPost('/api/w/gstMasterData/driverMasterData', requestToSend);
          //const result = await api.post('/api/w/gstMasterData/driverMasterData', drivers = null, transYard = null, defaultSalesOffice = "LGB");
          commit('updateSearchGSTDriverMasterRequest', fallbackRequest);
          console.log(JSON.stringify(result));
          return commit('updateGSTDriverMaster', result);
                },
      },

      getters: {
        getGSTDriverMaster: state => state.gstDriverMaster,
      },
}